<template>
    <div class="lang arabic">
        <div class="popup3">
            <div class="popup__wrap">
                <button type="button" class="close"><img src="/resource/icon/close-white.svg" alt=""></button>
                <div class="popup__inner">
                    <div class="cont">
                        <div class="img">
                            <img src="/resource/img/map-popup.jpg" alt="">
                        </div>
                    </div>
                    <button type="button" class="main-button c-main pc-none ">닫기</button>
                </div>
            </div>
        </div>
        <div class="map">
            <div class="map__box">
            <!-- <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.9040544340555!2d126.83368877629648!3d37.557324224655495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9d53d5ae7753%3A0xab7eac01f7498519!2z7J2064yA7ISc7Jq467OR7JuQ!5e0!3m2!1sko!2skr&hl=en!4v1729663845410!5m2!1sko!2skr"
        class="map__iframe" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d3162.89819678921!2d126.83364497629664!3d37.55746222464778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x357c9d53d5ae7753%3A0xab7eac01f7498519!2z7J2064yA7ISc7Jq467OR7JuQLCAyNjAgR29uZ2hhbmctZGFlcm8sIEdhbmdzZW8tZ3UsIFNlb3Vs!3m2!1d37.55732!2d126.83626369999999!5e0!3m2!1sen!2skr!4v1734414914990!5m2!1sen!2skr" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="map__iframe"></iframe>
                <div class="map__info">
                    <div class="map__address">
                        <h4 class="map__address-tit">العنوان</h4>
                        <ul class="map__address-list">
                            <li class="map__address-item">
                                <span>رقم القطعة</span>
                                <p>808 ماجوك دونغ ، جانجسيو جو ، سيول ، الطابق الثالث ، المبنى 3 ، مستشفى سيول التابعة لجامعة إيهوا النسائية ،</p>
                            </li>
                            <li class="map__address-item">
                                <span>عنوان اسم الطريق</span>
                                <p>260 غونغانغ -دايرو ، جانجسيو غو سيول جامعة إيهوا النسائية،</p>
                            </li>
                            
                        </ul>
                    </div>
                    <div class="map__btn">
                        <ul class="map__btn-list">
                            <li class="map__btn-item">
                                <a href="https://naver.me/x7nUngle" target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/naver-map-icon.png" alt=""></span>Naver Map</a>
                            </li>
                            <li class="map__btn-item">
                                <a href="https://kko.kakao.com/LZt68tdGtF" target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/kakao-map-icon.png" alt=""></span>Kakao Map</a>
                            </li>
                            <li class="map__btn-item">
                                <a href="https://maps.app.goo.gl/zw5QLy5U5hcae6ex9"
                                    target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/google-map-icon.png" alt=""></span>Google Map</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/bus.svg" alt=""></span>بواسطة حافلة منتظمة</h4>
            <p class="map__desc">
                دورة مستشفى موك دونج التابعة لجامعة إيهوا النسائية ↔ مستشفى سيول جامعة إيهوا النسائية</p>
            <div class="map__cont">
                <!-- <img src="/resource/img/map.png" alt=""> -->
                <div class="map__bus">
                    <div class="map__bus-inner">
                        <div class="box">
                            
                            <ul class="map__text">
                                <li class="top">محطة سيويو (المخرج 3)</li>
                                <li class="right">مستشفى سيول جامعة إيهوا النسائية</li>
                                <li class="bottom">محطة سيويو (المخرج 2)</li>
                                <li class="left">
                                    دورة مستشفى
                                    مواد دونج التابعة
                                    النسائية إيهوا
                                    جامعة 
                                </li>
                            </ul>
                            <div class="map__arrow">
                                <span v-for="i in 4" class="arrow"><img src="/resource/icon/arrow.svg" class="icon" alt=""></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table">
                    <table>
                        <colgroup>
                            <col style="width:20%;">
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>تصنيف</th>
                                <th>دورة مستشفى موك دونج التابعة لجامعة إيهوا النسائية</th>
                                <th>مستشفى سيول جامعة إيهوا النسائية</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>لحافلة الأولى</td>
                                <td>07:00</td>
                                <td>07:00</td>
                            </tr>
                            <tr>
                                <td><b>الحافلة الأخيرة</b></td>
                                <td>17:30</td>
                                <td>17:30</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="table-info">- يرجى الرجوع إلى الجدول الزمني للتشغيل على أساس الجدول الزمني . (يمكن تغيير جدول الحافلات قليلاً حسب حالة / حركة المرور على الطريق)</p>
                    <div class="botton-wrap">
                        <a href="javascript:;" class="main-button c-main">جدول الحافلات المنتظمة</a>
                    </div>
                </div>
            </div>

            <div class="line"></div>

            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/subway.svg" alt=""></span>بواسطة المترو</h4>
            <div class="map__cont">
                <div class="map__route mo">
                    <div>
                        <span class="name puple nowrap">الخط 5</span>
                        <!-- <em class="pc-none">Balsan Station</em> -->
                    </div>
                    <p>بواسطة المترو ، يخرج من 7 أو 8 من محطة بالسان</p>
                </div>
                <div class="map__route mo">
                    <div>
                        <span class="name yellow nowrap">الخط 9</span>
                        <!-- <em class="pc-none">Yangcheon Hyanggyo Station, Deungchon Station</em> -->
                    </div>
                    <p>
                        المخرج 8 من محطة يانجشيون هيانجيو(الخط 9) ← مدرسة يانجشن الابتدائية. استقل حافلة جانجسيو 06 في متحف جيومچاي چيونجسيون للفنون ← عند مخرج 7 من محطة بالسان،
<br>                        المخرج 1 من محطة ديونجشون ← مدرسة ديونجشون المتوسطة ، استقل حافلة 654 أو 661 أو 605 أو 60-3 أو 88 في محطة مدرسة بايكسيوك الابتدائية ← في محطة بالسان (خط 5) توقف بالحافلة
                    </p>
                </div>
            </div>

            <div class="line"></div>

            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/subway.svg" alt=""></span>الحافلة</h4>
            <ul class="map__list map__cont">
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">حافلات مدينة جانجسيو</span>
                        <p>Gangseo06</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">الحافلة</span>
                        <p>60, 60-3, 69, 88, 1002</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">الحافلة الخضراء</span>
                        <p>6629, 6630, 6632, 6645, 6648, 6712</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name blue">الحافلة الزرقاء</span>
                        <p>601, 605, 654, N26, N65</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name sky">حافلة المطا</span>
                        <p>6000(مطار جيمبو الدولي), 6003(مطار إنتشون الدولي), 6008</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name orange">السريعة</span>
                        <p>3000, 8000</p>
                    </div>
                </li>
            </ul>



        </div>
    </div>
</template>
<script>
    export default {

        mounted() {
            document.querySelector(".map .main-button").addEventListener("click", () => {
                document.querySelector(".popup3").classList.add("active")
            })

            document.querySelector(".popup3 .close").addEventListener("click", () => {
                document.querySelector(".popup3").classList.remove("active")
            })

            document.querySelector(".popup3 .main-button").addEventListener("click", () => {
                document.querySelector(".popup3").classList.remove("active")
            })
        },
    }

</script>
<style>

</style>